<template>
    <b-form-group
      label="Nota Fiscal"
      label-for="nota-fiscal"
      label-class="font_size_label nota_fiscal"
    >
      <validation-provider #default="{ errors }" name="Nota Fiscal">
        <v-select
          id="nota-fiscal"
          :options="options"
          v-model="selected"
          placeholder="Selecione a nota fiscal"
          label="descricao"
          :clearable="true"
          multiselect
          multiple
        >
          <span slot="no-options">Nenhuma opção selecionável.</span>
        </v-select>
        <small v-if="errors[0]" class="text-danger">
          {{ errors[0] }}
        </small>
      </validation-provider>
    </b-form-group>
  </template>
  
  <script>
  import {
    BForm,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BSpinner,
    BFormDatepicker,
    BFormTextarea,
    BOverlay,
  } from "bootstrap-vue";
  import { ValidationProvider, ValidationObserver } from "vee-validate";
  import vSelect from "vue-select";
  
  export default {
    components: {
      BForm,
      BCol,
      BRow,
      BFormGroup,
      BFormInput,
      BButton,
      BTable,
      BSpinner,
      BFormDatepicker,
      BFormTextarea,
      BOverlay,
      ValidationProvider,
      ValidationObserver,
      vSelect,
    },
    props: {
      value: {
        required: true,
      },
      optionsConsulted: {
        required: false,
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        options: [],
        selected: this.value,
        parametros: {
          params: {
            pagination: false,
            tamanho: 10000
          },
        },
      };
    },
    beforeMount() {
      this.setOptions();
    },
    methods: {
      async setOptions() {
        if (this.optionsConsulted.length > 0) {
          this.options = this.optionsConsulted;
          return;
        }
  
        await this.$http
          .get(this.$api.notaFiscal(), this.parametros)
          .then(({ data }) => {
            data.data.map((item) => {
              if(item.id_nota_fiscal !== 144){ // Duas notas fiscais com o mesmo id estão sendo retornadas do endpoint
                this.options.push({
                id_nota_fiscal: item.id_nota_fiscal,
                descricao: item.numero,
                });
              }  
            })
          });
      },
    },
    watch: {
      selected: function (valor) {
        this.$emit("selected", valor);
      },
      options: function (valor) {
        this.$emit("options", valor);
      },
    },
  };
  </script>